import Backbone from 'backbone'
import template from './geographic-ancestor-selector.hbs'
import _ from 'lodash'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import selects from 'scoreboard/components/selects'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import getRequiredGeographicAncestorTypes from 'scoreboard/datasets/edit/fields/get-required-geographic-ancestor-types'
import unwrapModel from 'scoreboard/components/unwrap-model'
import $ from 'jquery'
import PlaceholderSelect from 'scoreboard/components/placeholder-select'
import constants from 'scoreboard/components/constants'
import DataType from 'scoreboard/datasets/model/data-type'
const { COUNTRY, STATE_PROVINCE, CITY, POSTAL_CODE } = DataType

const CITY_FIELD_ID = 'cityFieldId'
const COUNTRY_FIELD_ID = 'countryFieldId'
const STATE_PROVINCE_FIELD_ID = 'stateProvinceFieldId'

const CITY_ID = 'cityId'
const COUNTRY_ID = 'countryId'
const STATE_PROVINCE_ID = 'stateProvinceId'

const GeographicAncestorSelector = Backbone.View.extend({

	/** @type { Dataset } */
	model: null,

	/** @type { DatasetField } */
	field: null,

	className: 'geographic-ancestor-selector',

	events: {
		'change [name=countryId]': 'onChangeCountryId',
		'change [name=stateProvinceId]': 'onChangeStateProvinceId',
		'change [name=cityId]': 'onChangeCityId'
	},

	initialize: function(options) {
		const [countryId, stateProvinceId, cityId] =
			options.geoSelections || [null, null, null]
		_.extend(this, { countryId, stateProvinceId, cityId })
		this.field = unwrapModel(options.field)
		this.options = options

		this.listenTo(this.options.field, 'change:dataType', (field) => {
			this.dataType = field.get('dataType')
			const oldDataTypeIsPostal =
				this.previousCountriesDataType === POSTAL_CODE
			const newDataTypeIsPostal = this.dataType === POSTAL_CODE
			const countryFetchNeeded =
				(oldDataTypeIsPostal && !newDataTypeIsPostal) ||
				(!oldDataTypeIsPostal && newDataTypeIsPostal)
			countryFetchNeeded && this.renderCountryIdSelect()

			this._onToggleChange()
		})

		this.markedFields = []

		this.dataType = this.field.dataType
		this.initialCountriesPromise = this.options.countries &&
			Promise.resolve(this.options.countries)
		this.initialStateProvincesPromise = this.options.stateProvinces &&
			Promise.resolve(this.options.stateProvinces)
		this.initialCitiesPromise = this.options.cities &&
			Promise.resolve(this.options.cities)
	},

	render: function() {
		this.$el.empty().append(template({}))

		this.renderAncestorTypeToggle()
		this.renderPlaceholderSelect()

		this.renderFields()
		this.markFields()

		this.toggleAllSelects()
	},

	renderFields: function() {
		this.renderCountryIdSelect()
		this.renderStateProvinceIdSelect({ initial: true })
		this.renderCityIdSelect({ initial: true })
		this.renderCountryFieldIdSelect()
		this.renderStateProvinceFieldIdSelect()
		this.renderCityFieldIdSelect()
	},

	markFields: function() {
		this.markField(COUNTRY_FIELD_ID)
		this.markField(STATE_PROVINCE_FIELD_ID)
		this.markField(CITY_FIELD_ID)

		this.markField(COUNTRY_ID)
		this.markField(STATE_PROVINCE_ID)
		this.markField(CITY_ID)
	},

	toggleAllSelects: function() {
		_.invokeMap(this.markedFields, 'removeError')
		this.$('.dataset-field').toggleClass('is-not-displayed',
			!this.isDatasetField())
		this.$('.specific-value').toggleClass('is-not-displayed',
			this.isDatasetField())

		if (this.isDatasetField()) {
			this.toggleOptionVisibility(COUNTRY_FIELD_ID, true)
			this.updateStateProvAndCityFieldIdSelectsVisibility()
		} else {
			this.toggleOptionVisibility(COUNTRY_ID, true)
			this.toggleOptionVisibility(STATE_PROVINCE_ID,
				this.requiresStateProvinceIdSelect())
			this.toggleOptionVisibility(CITY_ID, this.requiresCityIdSelect())
		}
	},

	getLocationTreeNodeId: function() {
		if (this.toggle.val() !== 'specific-value') return null
		return _([this.countryId, this.stateProvinceId, this.cityId])
			.compact()
			.last()
	},

	updateStateProvAndCityFieldIdSelectsVisibility: function() {
		const requiredAncestorTypes =
			getRequiredGeographicAncestorTypes(this.options.field.get('dataType'))
		const showStateProv = _.includes(requiredAncestorTypes, STATE_PROVINCE)
		const showCity = _.includes(requiredAncestorTypes, CITY)

		this.toggleOptionVisibility(STATE_PROVINCE_FIELD_ID, showStateProv)
		this.toggleOptionVisibility(CITY_FIELD_ID, showCity)
	},

	onChangeCountryId: function() {
		this.countryId = this.$('[name="countryId"]').val()
		delete this.stateProvinceId
		delete this.cityId

		if (!this.countryId) {
			this.toggleOptionVisibility(STATE_PROVINCE_ID, false)
			this.toggleOptionVisibility(CITY_ID, false)
		} else if (this.requiresStateProvinceIdSelect()) {
			this.renderStateProvinceIdSelect()
		}
	},

	onChangeStateProvinceId: function() {
		this.stateProvinceId = this.$('[name="stateProvinceId"]').val()
		delete this.cityId

		if (!this.stateProvinceId) {
			this.toggleOptionVisibility(CITY_ID, false)
		} else if (this.requiresCityIdSelect()) {
			this.renderCityIdSelect()
		}
	},

	onChangeCityId: function() {
		this.cityId = this.$('[name="cityId"]').val()
	},

	isDataTypeRequired: function(dataType) {
		const requiredAncestorTypes =
			getRequiredGeographicAncestorTypes(this.options.field.get('dataType'))
		return _.includes(requiredAncestorTypes, dataType)
	},

	renderCountryIdSelect: function() {
		this._fetchCountries().then(countries => {
			const options = countries.map(({id, label}) => ({
				id,
				label,
				selected: id == this.countryId
			}))
			const el = this.$('[name="countryId"]')
			selects.filtering(el, {
				accessors: { 'value': 'id' },
				stayOpenOnSelect: false,
				options
			})
			selects.val(el, this.countryId)
		})
	},

	markField: function(propName) {
		this[`${propName}MarkedField`] = new MarkedField({
			el: this.$(`[name="${propName}"]`),
			validator: requiredValidator
		}).render()
		this.markedFields.push(this[`${propName}MarkedField`])
	},

	renderCountryFieldIdSelect: function() {
		this.renderFieldIdSelect(COUNTRY_FIELD_ID)
	},

	requiresStateProvinceIdSelect: function() {
		return !_.isNil(this.countryId) &&
			this.isDataTypeRequired(STATE_PROVINCE)
	},

	// Can't be run until a country has been selected, and must be run every time
	// that happens
	renderStateProvinceIdSelect: function(opts={}) {
		this._fetchStateProvinces(this.countryId).then(stateProvinces => {
			if (!_.isEmpty(stateProvinces) && !opts.initial) {
				this.toggleOptionVisibility(STATE_PROVINCE_ID, true)
			}
			const options = stateProvinces.map(({id, label}) => ({
				id,
				label,
				selected: id == this.stateProvinceId
			}))
			const el = this.$('[name="stateProvinceId"]')
			selects.filtering(el, {
				accessors: { 'value': 'id' },
				stayOpenOnSelect: false,
				options
			})
			selects.val(el, this.stateProvinceId)
		})
	},

	// Can be run initially without knowing the country field selection
	renderStateProvinceFieldIdSelect: function() {
		this.renderFieldIdSelect(STATE_PROVINCE_FIELD_ID)
	},

	requiresCityIdSelect: function() {
		return !_.isNil(this.stateProvinceId) &&
			this.isDataTypeRequired(CITY)
	},

	renderCityIdSelect: function(opts={}) {
		if (!this.requiresCityIdSelect()) return
		this._fetchCities(this.stateProvinceId).then(cities => {
			if (!_.isEmpty(cities) && !opts.initial) {
				this.toggleOptionVisibility(CITY_ID, true)
			}
			const options = cities.map(({ id, label }) => ({
				id,
				label,
				selected: id == this.cityId
			}))
			const el = this.$('[name="cityId"]')
			selects.filtering(el, {
				accessors: { 'value': 'id' },
				stayOpenOnSelect: false,
				options
			})
			selects.val(el, this.cityId)
		})
	},

	renderCityFieldIdSelect: function() {
		this.renderFieldIdSelect(CITY_FIELD_ID)
	},

	renderFieldIdSelect: function(selectFieldType) {
		const options = this.getFieldSelectOptions(selectFieldType)
		const el = this.$(`[name=${selectFieldType}]`)

		selects.filtering(el, {
			accessors: { 'value': 'id' },
			stayOpenOnSelect: false,
			options
		})
	},

	getFieldSelectOptions: function(selectFieldType) {
		return this.model.get('fields')
			.filter(it => it.id && it.id != this.field.id)
			// #48337 filter out only the fields that are valid to select, given the
			// parent field's data type/propName
			.filter(field => {
				if (selectFieldType === COUNTRY_FIELD_ID) {
					return field.dataType === COUNTRY
				}
				if (selectFieldType === STATE_PROVINCE_FIELD_ID) {
					return field.dataType === STATE_PROVINCE
				}
				if (selectFieldType === CITY_FIELD_ID) {
					return field.dataType === CITY
				}
				return false
			})
			.map(({ id, label }) => ({
				id,
				label,
				selected: id == this.field[selectFieldType]
			}))
	},

	renderAncestorTypeToggle: function() {
		const { countryFieldId, stateProvinceFieldId, cityFieldId } = this.field
		const isDatasetField = _.compact([
			countryFieldId, stateProvinceFieldId, cityFieldId
		]).length != 0
		this.toggle = new LabeledToggle({
			options: [{
				value: 'specific-value',
				label: 'datasets.datatype.groups.geographic.parentType.specificValue'
			},{
				value: 'dataset-field',
				label: 'datasets.datatype.groups.geographic.parentType.datasetField'
			}],
			value: isDatasetField ? 'dataset-field' : 'specific-value',
			name: 'geographicAncestorType'
		})
		this.listenTo(this.toggle, 'change', () => this._onToggleChange())
		this.$('.toggle-container').append(this.toggle.el)
		this.toggle.render()
	},

	renderPlaceholderSelect: function() {
		this.placeholderSelect = new PlaceholderSelect()

		// #51732 we don't want this placeholder select controlled by the parent
		// field-form, so add the 'exempted' class
		this.placeholderSelect.$el.addClass('exempted')

		this.$('.placeholder-select').replaceWith(this.placeholderSelect.el)
		this.placeholderSelect.render()
	},

	isDatasetField: function() {
		return this.toggle.val() === 'dataset-field'
	},

	_onToggleChange: function() {
		this.toggleAllSelects()
		_.invokeMap(this.markedFields, 'clearError')

		// the metadata will provide subdivisions suggestions by default if
		// no node is previously selected so will need to refetch here
		if (this.dataType === POSTAL_CODE &&
			this.previousCountriesDataType !== POSTAL_CODE) {
			this.renderCountryIdSelect()
		}
	},

	_setLoading: function(loading) {
		this.placeholderSelect.toggle(loading)
	},

	_fetchCountries: function() {
		const treeId = this.dataType === POSTAL_CODE ?
			constants.POSTAL_CODES_ROLLUP_ID : constants.SUBDIVISIONS_ROLLUP_ID

		this._setLoading(true)
		const promise = (this.initialCountriesPromise || $.get(
			`api/locations/countries/${treeId}`
		)).then(result => {
			this._setLoading(false)
			return result
		})
		if (!this.initialCountriesPromise) {
			this.previousCountriesDataType = this.dataType
		}
		delete this.initialCountriesPromise

		return promise
	},

	_fetchStateProvinces: function(countryId) {
		if (_.isNil(countryId)) return Promise.resolve([])

		this._setLoading(true)
		const promise = (this.initialStateProvincesPromise || $.get(
			`api/locations/countries/${countryId}/state-provinces`
		)).then(result => {
			this._setLoading(false)
			return result
		})
		delete this.initialStateProvincesPromise
		return promise
	},

	_fetchCities: function(stateProvinceId) {
		if (_.isNil(stateProvinceId)) return Promise.resolve([])

		this._setLoading(true)
		const promise = (this.initialCitiesPromise || $.get(
				`api/locations/countries/state-provinces/${stateProvinceId}/cities`
		)).then(result => {
			this._setLoading(false)
			return result
		})
		delete this.initialCitiesPromise
		return promise
	},

	toggleOptionVisibility: function(propType, show) {
		if (!show) this[`${propType}MarkedField`].clearError()
		this.$(`.${this.getOptionClass(propType)}`)
			.toggleClass('is-not-displayed', !show)
	},

	// translates the propType to corresponding option
	// for example, countryId and countryFieldId would both translate to
	// country-option
	getOptionClass: function(propType) {
		let optionType = _.split(propType, 'Id', 1)
		optionType = _.split(optionType, 'Field', 1)
		optionType = _.kebabCase(optionType)
		return `${optionType}-option`
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.toggle, ...this.markedFields], 'remove')
	}
})

export default GeographicAncestorSelector
export { CITY_FIELD_ID }
export { COUNTRY_FIELD_ID }
export { STATE_PROVINCE_FIELD_ID }
GeographicAncestorSelector.__filename__ = 'datasets/edit/fields/geographic-ancestor-selector.js'
